import componentShell from "./shell"
import SiteMenu from "@/menu/components/site_menu"

export default componentShell(SiteMenu)
